import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const fjInterestsApi = createApi({
  reducerPath: 'fjInterestsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    // Endpoint pre vratenie danej Interest
    getInterest: builder.query({
      query(id) {
        return {
          url: urls.friJobsInterestsDetail(id),
          method: 'GET',
        };
      },
    }),
    // Endpoint pre vratenie zaujmov o pracovne ponuky (Studenta)
    getStudentInterests: builder.query({
      query() {
        return {
          url: urls.friJobsMyInterests,
          method: 'GET',
        };
      },
    }),
    // Endpoint pre ulozenie zaujmu o pracovnu ponuku
    saveInterest: builder.mutation({
      query(req) {
        const data = {
          fj_job_id: req.fj_job_id,
          resume_object: req.resume_object,
          motiv_letter_object: req.motiv_letter_object,
          phone: req.phone,
          mail: req.mail,
        };

        let packedData = new FormData();
        Object.keys(data).forEach((key) => {
          let dataValue = data[key];
          if (dataValue) {
            packedData.append(key, dataValue);
          }
        });

        if (req.id) {
          // Toto je workaround na to, že to nejde
          packedData.append('_method', 'put');
          return {
            url: urls.friJobsInterestEdit(req.id),
            // Malo by tu byť PUT, ale potom je v Laraveli prázdny request
            // Vraj to známa dlhoročná chyba v PHP
            method: 'POST',
            data: packedData,
          };
        } else {
          return {
            url: urls.friJobsInterests,
            method: 'POST',
            data: packedData,
          };
        }
      },
    }),
    // Endpoint pre zmazanie zaujmu o pracovnu ponuku
    deleteInterest: builder.mutation({
      query(id) {
        return {
          url: urls.friJobsInterestsDelete(id),
          method: 'DELETE',
        };
      },
    }),

    // Authenticated private file downloads
    downloadCv: builder.query({
      query(id) {
        return {
          url: urls.friJobsInterestCv(id),
          method: 'GET',
          responseType: 'blob',
        };
      },
      transformResponse: (data) => data, // { blob, headers }
    }),
    downloadMotivationLetter: builder.query({
      query(id) {
        return {
          url: urls.friJobsInterestMotivationLetter(id),
          method: 'GET',
          responseType: 'blob',
        };
      },
      transformResponse: (data) => data, // { blob, headers }
    }),
  }),
});

export const {
  useGetInterestQuery,
  useGetStudentInterestsQuery,
  useSaveInterestMutation,
  useDeleteInterestMutation,
  useLazyDownloadCvQuery,
  useLazyDownloadMotivationLetterQuery,
} = fjInterestsApi;
